"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMAT_IDENTITY_ETHEREUM_ADDRESS_LENGTH = exports.FORMAT_NORMALIZE_KECCAK256_HASH_LENGTH = exports.prefix = exports.PlainTypes = exports.HashTypes = void 0;
const HashTypes = __importStar(require("./multi-format/hash-types"));
exports.HashTypes = HashTypes;
const PlainTypes = __importStar(require("./multi-format/plain-types"));
exports.PlainTypes = PlainTypes;
/** Prefix of handled data format */
var prefix;
(function (prefix) {
    prefix["PLAIN_TEXT"] = "00";
    /** the data is Keccak256 hash of normalized data (sorted object, stringify and lowercase) */
    prefix["NORMALIZE_KECCAK256_HASH"] = "01";
    /** ECIES encrypted data */
    prefix["ECIES_ENCRYPTED"] = "02";
    /** AES256-CBC encrypted data */
    prefix["AES256_CBC_ENCRYPTED"] = "03";
    /** AES256-GCM encrypted data */
    prefix["AES256_GCM_ENCRYPTED"] = "04";
    /** KMS encrypted data */
    prefix["KMS_ENCRYPTED"] = "05";
    /** Identity Ethereum address */
    prefix["IDENTITY_ETHEREUM_ADDRESS"] = "20";
})(prefix || (exports.prefix = prefix = {}));
/** Length of a formatted normalized Keccak256 hash (prefix + hash = 2 + 64 = 66) (no 0x expected) */
exports.FORMAT_NORMALIZE_KECCAK256_HASH_LENGTH = 66;
/** Length of a formatted ethereum address identity (prefix + address = 2 + 40 = 42) (no 0x expected) */
exports.FORMAT_IDENTITY_ETHEREUM_ADDRESS_LENGTH = 42;
//# sourceMappingURL=multi-format-types.js.map